import _classCallCheck from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import ToolTip from './tooltip-component';
import { getTouchEvent as touchSafeEvent } from '../../../fc-core/src/lib';
var TOOL_TIP_KEY = '__FC_tooltipText',
    MOVE_HANDLER = '__FC_onTooltipMove',
    OUT_HANDLER = '__FC_onTooltipOut',
    OVER_HANDLER = '__FC_onTooltipOver';

var moveHandler = function moveHandler(a, b, c) {
  c = touchSafeEvent(c);
  var d = b.universe.getBoundingClientRect(),
      e = c.clientX,
      f = c.clientY;
  e -= d.left, f -= d.top, e += 11, f += 11, ToolTipController._draw.call(b, e, f, this.data(TOOL_TIP_KEY), a);
},
    outHandler = function outHandler(a) {
  ToolTipController._hide(a);
};

var ToolTipController =
/*#__PURE__*/
function () {
  function ToolTipController(a) {
    _classCallCheck(this, ToolTipController);

    var b = this,
        c = b.config = {};
    b.universe = a, b.toolTips = {
      implicit: [],
      explicit: []
    }, b.hideImplicitToolTip = function (a) {
      var d = c.lastActiveToolip;
      d && a.target !== d.getData('targetElement').node && (ToolTipController._hide(d), b.config.lastActiveToolip = void 0);
    }, b.config.positioningArr = [], b.config.canvasArr = [], a.FusionCharts.jsVars.fcObj.addEventListener('resized', b._updateAllToolTipBounds.bind(b));
  }

  _createClass(ToolTipController, [{
    key: "_updateAllToolTipBounds",
    value: function _updateAllToolTipBounds() {
      var a,
          b,
          c,
          d = this,
          e = d.config,
          f = e.canvasArr,
          g = e.positioningArr,
          h = function h(b) {
        b.universeBounds && (c = b.universeBounds.canvas) && (a = f.indexOf(c)), b.setUniverseBounds(g[a]);
      },
          i = d.toolTips;

      for (b in i) {
        i[b].forEach(h);
      }
    }
  }, {
    key: "_setRelativePosition",
    value: function _setRelativePosition(a) {
      var b = this,
          c = b.config,
          d = c.canvasArr,
          e = c.positioningArr,
          f = d.indexOf(a.canvas);
      -1 === f ? (d.push(a.canvas), e.push(a)) : (d[f] = a.canvas, e[f] = a);
    }
  }, {
    key: "_createToolTip",
    value: function _createToolTip(a, b) {
      var c,
          d = this,
          e = d.config,
          f = e.canvasArr,
          g = e.positioningArr,
          h = f.indexOf(b);
      return c = new ToolTip(this.universe, g[h]), c.setStyle(this.config.tooltipStyle), d.toolTips[a].push(c), c;
    }
  }, {
    key: "enableToolTip",
    value: function enableToolTip(a, b, c) {
      var d,
          f = this,
          e = f.toolTips.implicit,
          g = e.length,
          h = f.config;
      return b ? a.data(TOOL_TIP_KEY) ? (0 < g && (d = e[g - 1], d.getData('active') && d.show(b)), a.data(TOOL_TIP_KEY, b), f) : (d = f._getAvailableToolTip('implicit', c), f.disableToolTip(a), a.data(TOOL_TIP_KEY, b), a.data(MOVE_HANDLER, moveHandler.bind(a, d, f)), a.data(OUT_HANDLER, outHandler.bind(a, d)), a.data(OVER_HANDLER, function (b) {
        return function (c) {
          f.draw(c, a.data(TOOL_TIP_KEY), d), d.setData('targetElement', b), h.lastActiveToolip = d;
        };
      }(a)), a.on('fc-mousemove', a.data(MOVE_HANDLER)), a.on('fc-mouseout', a.data(OUT_HANDLER)), a.on('fc-mouseover', a.data(OVER_HANDLER)), f) : (f.disableToolTip(a), f);
    }
  }, {
    key: "disableToolTip",
    value: function disableToolTip(a) {
      var b = a.data(OUT_HANDLER),
          c = a.data(MOVE_HANDLER),
          d = a.data(OVER_HANDLER);
      return c && a.off('fc-mousemove', c), b && a.off('fc-mouseout', b), d && a.off('fc-mouseover', d), a.removeData(TOOL_TIP_KEY), this;
    }
  }, {
    key: "draw",
    value: function draw(a, b, c, d) {
      var e,
          f,
          g = this.universe.getBoundingClientRect();
      return a = touchSafeEvent(a), e = a.clientX, f = a.clientY, c = c && !c.disposed ? c : this._getAvailableToolTip('explicit', d), e -= g.left, f -= g.top, e += 11, f += 11, ToolTipController._draw.call(this, e, f, b, c), c;
    }
  }, {
    key: "drawAt",
    value: function drawAt(a, b, c, d, e) {
      return d = d && !d.disposed ? d : this._getAvailableToolTip('explicit', e), ToolTipController._draw.call(this, a, b, c, d), d;
    }
  }, {
    key: "_getAvailableToolTip",
    value: function _getAvailableToolTip(a, b) {
      var c,
          d,
          e = this.toolTips[a];

      for (var f = 0, g = e.length; f < g; f++) {
        if (c = e[f], d = !1 === c.getData('active'), d) return c;
      }

      return this._createToolTip(a, b);
    }
  }, {
    key: "setStyle",
    value: function setStyle(a) {
      var b = this,
          c = b.config,
          d = c.tooltipStyle || (c.tooltipStyle = {});

      for (var e in a) {
        d[e] = a[e];
      }
    }
  }, {
    key: "hide",
    value: function hide(a) {
      return ToolTipController._hide(a), this;
    }
  }, {
    key: "hideAll",
    value: function hideAll() {
      var a,
          b,
          c = this;

      for (a in c.toolTips) {
        for (b = 0; b < c.toolTips[a].length; b++) {
          ToolTipController._hide(c.toolTips[a][b]);
        }
      }
    }
  }], [{
    key: "_draw",
    value: function _draw(a, b, c, d) {
      d.show(c), d.update(a, b);
    }
  }, {
    key: "_hide",
    value: function _hide(a, b) {
      a && (b ? a.dispose() : a.hide());
    }
  }]);

  return ToolTipController;
}();

export default {
  extension: ToolTipController,
  name: 'ToolTipController',
  type: 'plugin'
};